import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { formatDateTime } from "@madmedical/utils";
import { Box, HStack, Text } from "native-base";
import { PREGNANCY_SYMPTOMS_FOR_HUMANS } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import ReactTable from "../../molecules/ReactTable";
import ActionButton from "../../molecules/ActionButton";
import PregnantMoodPics from "../../molecules/Pregnancy/PregnantMoodPics";
import Tag from "../../atoms/Tag";
import { usePregnancy } from "../../providers";
const PregnancyFeelingTable = ({ data, onEndReached, isDoctor = false, }) => {
    const { onEditPress, onDeletePress } = usePregnancy();
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            Header: t("appointment"),
            accessor: "createdAt",
            width: "120px",
            minWidth: 120,
            Cell: ({ value }) => value ? _jsx(Box, { children: formatDateTime(value) }) : _jsx(Box, { children: "-" }),
        },
        {
            Header: t("feeling"),
            accessor: "status",
            width: "60px",
            maxWidth: 60,
            Cell: ({ value }) => (_jsx(Box, Object.assign({ w: "64px", h: "64px" }, { children: _jsx(PregnantMoodPics, { status: value }) }))),
        },
        {
            Header: t("symptoms"),
            accessor: "symptoms",
            width: "25%",
            maxWidth: 120,
            Cell: ({ value }) => (_jsx(HStack, Object.assign({ space: 1, flexWrap: "wrap", width: "full" }, { children: value === null || value === void 0 ? void 0 : value.map((symptom) => (_jsx(Tag, Object.assign({ my: 1 }, { children: PREGNANCY_SYMPTOMS_FOR_HUMANS[symptom] }), symptom))) }))),
        },
        {
            Header: "Bejegyzés",
            accessor: "comment",
            Cell: ({ value }) => value ? (_jsx(Text, Object.assign({ isTruncated: true, noOfLines: 6, maxWidth: "95%" }, { children: value }))) : (_jsx(Box, { children: "-" })),
        },
        {
            Header: "",
            id: "action",
            width: 40,
            Cell: ({ row: { original: measurement }, }) => (_jsx(Box, Object.assign({ flexDirection: "row", justifyContent: "flex-end", w: "full" }, { children: _jsx(ActionButton, { size: "xs", actions: (measurement === null || measurement === void 0 ? void 0 : measurement.editable) && !isDoctor
                        ? [
                            {
                                text: t("edit"),
                                iconName: "edit",
                                onPress: () => onEditPress === null || onEditPress === void 0 ? void 0 : onEditPress(measurement),
                            },
                            {
                                text: t("delete"),
                                iconName: "trashCan",
                                onPress: () => {
                                    onDeletePress === null || onDeletePress === void 0 ? void 0 : onDeletePress(measurement.id);
                                },
                            },
                        ]
                        : [] }) }))),
        },
    ], [onDeletePress, onEditPress, isDoctor, t]);
    return (_jsx(ReactTable, { columns: columns, data: data, onEndReached: onEndReached }));
};
export default PregnancyFeelingTable;
